import { push } from "redux-first-history";

import { CreateActionCreator } from "../../../state/loading/actions";
import { actionCreator } from "../../../state/utils";

export interface ISetAuthTokenPayload {
  access_token: string;
  expires_on?: number;
}

export const LogoutActionCreator = actionCreator<"LOGOUT">("LOGOUT");
export const LoginSuccessActionCreator = actionCreator<"LOGIN_SUCCESS">("LOGIN_SUCCESS");
export const SetAuthTokenActionCreator = actionCreator<"SET_AUTH_TOKEN", ISetAuthTokenPayload>("SET_AUTH_TOKEN");

export type AuthActions =
  | ReturnType<typeof LoginSuccessActionCreator>
  | ReturnType<typeof LogoutActionCreator>
  | ReturnType<typeof SetAuthTokenActionCreator>;

export const FetchTokenWithCredentials = CreateActionCreator(
  "LOGIN_WITH_CREDS",
  async (dispatch, getState, username: string, password: string, thenLogin?: boolean) => {
    dispatch(LogoutActionCreator());

    const result = await fetch(`${getState().config.apiUrl}/signin`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: username, password }),
    });

    if (result.status !== 200) {
      throw new Error(await result.text());
    }

    const { token }: { token: string } = await result.json();

    dispatch(SetAuthTokenActionCreator({ access_token: token }) as any);
    if (thenLogin) {
      await dispatch(Login() as any);
    }
  }
);

// TODO: Handle "anonymous participant" auth somehow
export const Login = CreateActionCreator("LOGIN_LOADING", async (dispatch, getState) => {
  const accessToken = getState().authV2?.token?.access_token;
  const location = getState().router.location;

  if (!accessToken) {
    console.log("No stored token. The user must log in");
    dispatch(push("/auth/login", { from: location }));
  } else {
    try {
      console.log("Stored token found, validating...");
      const result = await fetch(`${getState().config.apiUrl}/current_user`, {
        headers: { authorization: accessToken },
      });

      if (result.status !== 200) {
        throw new Error(await result.text());
      }

      const { token } = await result.json();
      dispatch(SetAuthTokenActionCreator({ access_token: token }) as any);
      dispatch(LoginSuccessActionCreator() as any);
      const locationState = location && typeof location === "object" && "state" in location ? location.state : null;
      if (locationState && typeof locationState === "object" && "from" in locationState && locationState.from) {
        dispatch(push(locationState.from as string, { replace: true }) as any);
      } else if (
        location &&
        typeof location === "object" &&
        "pathname" in location &&
        location.pathname === "/auth/login"
      ) {
        dispatch(push("/") as any);
      }
    } catch (e) {
      console.log("Failed to refresh. The user must re-login. Error: ", e);
      dispatch(push("/auth/login", { from: location }));
    }
  }
});

export const initialActions = [Login()];
